import IconTooltip from "ui/Tooltip/IconTooltip";
import React, {Fragment} from "react";
import {MisSystemStatusArray} from "root/s360components/Registration/MisSystemWritebackStatus";
import useModalMisWritebackInfo, {
    ModalMisWritebackInfoModes
} from "root/s360components/Modals/MisWritebackInfo/useModalMisWritebackInfo";


const MisStatusIcon = ({status_id}) =>
{

    const [renderModalMisWritebackInfo, activateModalMisWritebackInfo] = useModalMisWritebackInfo();

    const onClickIcon = () =>
    {
        activateModalMisWritebackInfo({mode: ModalMisWritebackInfoModes.VIEW});
    }

    const misSystemObj = MisSystemStatusArray.reduce((result, currentValue) => {
        if (status_id === currentValue.status_id)
        {
            return currentValue;
        }
        else
        {
            return result
        }
    }, null);

    return (
        <Fragment>
            <IconTooltip icon={misSystemObj.icon} color={misSystemObj.color} placement='top' text={misSystemObj.status_text} onClick={onClickIcon}/>
            {renderModalMisWritebackInfo()}
        </Fragment>
);
}

export default MisStatusIcon;